import { render, staticRenderFns } from "./CambiarContrasena.vue?vue&type=template&id=3033d41e"
import script from "./CambiarContrasena.vue?vue&type=script&lang=js"
export * from "./CambiarContrasena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports